import { transformToCdnUrl } from 'utils/google-storage-util';
import base from './tile-art.module.css';
import styles from './CodTileArt.module.css';

export const CodTileArt: React.FC = () => (
    <>
        <img
            className={`${base.layer} ${styles.box}`}
            src={transformToCdnUrl('embedded-assets/tiles/cod-illustration-tile-3.webp')}
            width={748}
            height={616}
            alt=""
            aria-hidden="true"
            loading="lazy"
        />
        <img
            className={`${base.layer} ${styles.terminal}`}
            src={transformToCdnUrl('embedded-assets/tiles/cod-illustration-tile-2.webp')}
            width={797}
            height={653}
            alt=""
            aria-hidden="true"
            loading="lazy"
        />
        <img
            className={`${base.layer} ${styles.card}`}
            src={transformToCdnUrl('embedded-assets/tiles/cod-illustration-tile-1.webp')}
            width={601}
            height={734}
            alt=""
            aria-hidden="true"
            loading="lazy"
        />
    </>
);
